import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Uploader from "./Uploader";

export default class Manager extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.elements = $('.is-uploader');
    this.start();
    return super.initialize();
  }

  start() {

    this.elements.each((index, element) => {

      return new Uploader(
        this.App,
        this.namespace,
        $(element)
      );

    });

  }

}